/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Container, Form, Row, Spinner, Button } from 'react-bootstrap';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import SearchIcon from '@mui/icons-material/Search';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import CheckboxInput from 'components/input/CheckboxInput';
import LoadingContent from 'components/LoadingContent';
import { scrollToObject } from 'components/helper/ui_helper';
import { ExpandMore } from 'screen/activitiesAndHonors/Activities';
import { ModalCheckCollgeCourseField } from 'screen/common/ModalCheckCollgeCourseField';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/hooks'; 
import { useFormik } from 'formik';
import { routers } from 'router/router';
import { reorder, tryParseJSON } from 'components/helper/helper';
import CollegeCourseConfig from './components/CollegeCourseConfig';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getGradeAndCourse, updateGradeAndCourse } from 'app/course/courseSlice';
import { getCollege } from 'app/highSchoolSlice/highSchoolSlice';
import { debounce } from 'lodash';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { ModalConfirm } from 'screen/common/ModalConfirm';
import { FormCollegeCourse } from 'modal/course';

interface Props {}

const CollegeCourse = (props: Props) => {
  const MAX_COLLEGE_TERMS = 20;
  const [myColleges, setMyColleges] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [showWarning, setShowWarning] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [errorArr, setErrorArr] = React.useState<any[]>([]);
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  //const [isRemoving, setIsRemoving] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const course = useAppSelector((store) => store.course);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const [courseData, setCourseData] = React.useState<any[]>([]);
  // Keep latest courseData for formik onSubmit — avoids stale [] wipe on autosave
  const courseDataRef = React.useRef<any[]>(courseData);
  React.useEffect(() => {
    courseDataRef.current = courseData;
  }, [courseData]);
  // const query = new URLSearchParams(location.search);
  // const check = query.get('check');

  const formik = useFormik({
    initialValues: {
      college_course_array: '',
      is_finish_adding_all_college_grade: false,
    },
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          const latestCourseData = courseDataRef.current ?? [];
          const newValues = {
            ...values,
            student_id: studentId,
            update_grade_no: '13',
            college_course_array: JSON.stringify(latestCourseData),
          };

          await dispatch(updateGradeAndCourse(newValues));
          // Remove recheckInputSchool completely to prevent infinite loop
         
        } catch (ex) {
          console.log('Error:', ex);
        }
      } else {
        handleLogout();
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    history.push(routers.generalTest.path);
  };

  const handleCheckMissingFields = () => {
    setShowMissingFieldsModal(true);
  };

  const checkInputSchool = async (courseArr: any[], myColleges: any) => {
    let arr: any[] = [];
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      console.log('myColleges:', myColleges);
      if (myColleges) {
        const colleges: any[] = tryParseJSON(myColleges.colleges_taken_coursework_array, []);
        //console.log('colleges:', colleges);
        //console.log('courseArr:', courseArr);
        if (colleges.length === 0) {
          arr.push({
            value: 'number_of_colleges_taken_coursework',
            name: 'Please add high college on the Colleges & Universities page.',
          });
        } else {
          if (colleges && colleges.length) {
            for (let i = 0; i < colleges.length; i++) {
              let item: any = colleges[i];
              let college_name = colleges[i].college_name;
              if (courseArr && courseArr.length > 0) {
                for (let j = 0; j < courseArr.length; j++) {
                  let course = courseArr[j];
                  if (course?.collegeName === college_name) {
                    if (college_name === '') {
                      arr.push({
                        value: `collegeName_${i + 1}`,
                        name: 'Please search and select/enter College/University name on the Colleges & Universities page.',
                      });
                    } else {
                      if (!item?.fromDate && !item?.toDate) {
                        arr.push({
                          value: `fromDate_${i + 1}`,
                          name: 'Please enter the From date and To date on the Colleges & Universities page.',
                        });
                      } else if (!item.fromDate) {
                        arr.push({
                          value: `fromDate_${i + 1}`,
                          name: 'Please enter the From date on the Colleges & Universities page.',
                        });
                      } else if (!item.toDate) {
                        arr.push({
                          value: `toDate_${i + 1}`,
                          name: 'Please input the To date on the Colleges & Universities page.',
                        });
                      }
                    }
                  }
                }
              } else {
              }
            }
          }
        }
      }
      if (arr.length > 0) {
        setShowWarning(true);
        setErrorArr(arr);
      } else {
        setShowWarning(false);
      }
    } else {
      handleLogout();
    }
  };

  // const recheckInputSchool = async () => {
  //   studentId = getUserId();
  //   token = getAccessToken();
  //   if (token && studentId) {
  //     const ret = await dispatch(getCollege(studentId)).unwrap();
  //     const dataLoaded = await dispatch(getGradeAndCourse(studentId)).unwrap();
  //     let courseArr = tryParseJSON(dataLoaded.college_course_array) ?? [];
  //     await checkInputSchool(courseArr, ret);
  //   } else {
  //     handleLogout();
  //   }
  // };

  const AutoScrollAndExpand = () => {
    const expandDiv = (divId: string) => {
      let div = document.getElementById(divId);
      if (div) {
        if (div.getAttribute('aria-expanded') === 'false') {
          div.click();
        }
      }
    };
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      if (hash) {
        if (hash === 'AddCollege') {
          setTimeout(() => {
            scrollToObject(hash, 200);
          }, 1500);
        } else if (hash.includes('collegeName_')) {
          let str = hash.replaceAll('collegeName_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 200);
            }, 1500);
          }, 2000);
        } else if (hash.includes('academicYear_')) {
          let str = hash.replaceAll('academicYear_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('academicStatus_')) {
          let str = hash.replaceAll('academicStatus_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('scheduleSystem_')) {
          let str = hash.replaceAll('scheduleSystem_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('term_')) {
          let str = hash.replaceAll('term_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        }

        if (hash.includes('dept_')) {
          let str = hash.replaceAll('dept_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('courseNumber_')) {
          let str = hash.replaceAll('courseNumber_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('courseName_')) {
          let str = hash.replaceAll('courseName_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('subject_')) {
          let str = hash.replaceAll('subject_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('completionStatus_')) {
          let str = hash.replaceAll('completionStatus_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('grade_')) {
          let str = hash.replaceAll('grade_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        }

        //
        else if (true) {
          //skip
        }
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const getDetail = async (isMounted?: boolean) => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      try {
        if (isMounted) {
          setLoading(true);
        }

        const pageStatus: {
          student_completed: boolean;
        } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.COLLEGE_COURSE);
        if(pageStatus) {
          setReviewedAndComplete(pageStatus.student_completed);
        }
        
        const ret = await dispatch(getCollege(studentId)).unwrap();
        if (isMounted) {
          setMyColleges(ret);
        }

        const dataLoaded = await dispatch(getGradeAndCourse(studentId)).unwrap();
        if (dataLoaded && isMounted) {
          // Temporarily disable auto save during initial load
          notInitialRender.current = false;
          
          formik.setValues({
            ...formik.values,
            ...dataLoaded,
            is_finish_adding_all_college_grade: dataLoaded.is_finish_adding_all_college_grade,
          });

          let courseArr = tryParseJSON(dataLoaded.college_course_array) ?? [];
          setCourseData(courseArr);

          await checkInputSchool(courseArr, ret);

          setTimeout(() => {
            if (isMounted) {
              AutoScrollAndExpand();
            }
          }, 2000);
          
          // Reset form dirty state after loading data
          formik.resetForm({ values: {
            ...formik.values,
            ...dataLoaded,
            is_finish_adding_all_college_grade: dataLoaded.is_finish_adding_all_college_grade,
          }});
        }
        if (isMounted) {
          setLoading(false);
          formik.setStatus('idle');
          // Re-enable auto save after initial data load
          notInitialRender.current = true;
        }
      } catch (ex) {
        console.log('Error: ', ex);
        if (isMounted) {
          setLoading(false);
        }
      }
    } else {
      if (isMounted) {
        handleLogout();
      }
    }
  };
  React.useEffect(() => {
    let isMounted = true;
    
    const loadData = async () => {
      if (isMounted) {
        await getDetail(isMounted);
      }
    };
    
    loadData();
    
    // Cleanup function
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const hash = location.hash.slice(1); // Remove the '#' character from the hash
    if (hash) {
      AutoScrollAndExpand();
    }
  }, [location]);

  const handleAddCollege = () => {
    if (courseData.length > MAX_COLLEGE_TERMS - 1) return;
    setCourseData([
      ...courseData,
      {
        collegeName: '',
        collegeInformation: null,
        scheduleSystem: '',
        academicYear: '',
        term: '',
        academicStatus: '',
        collegeCourseArray: [],
      },
    ]);
  };

  const handleExpandAll = () => {
    setExpandAll(!expandAll);
    if (!expandAll) {
      setExpandActive(courseData.length);
    } else {
      setExpandActive(0);
    }
  };

  const handleExpandActive = (value: any) => {
    value
      ? setExpandActive(Math.abs(expandActive - 1))
      : setExpandActive(Math.abs(expandActive + 1));
  };

  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.COLLEGE_COURSE, reviewedAndComplete, setReviewedAndComplete);
  }

  React.useEffect(() => {
    if (expandActive === courseData.length) {
      setExpandAll(true);
    }

    if (expandActive === 0) {
      setExpandAll(false);
    }
  }, [expandActive, courseData.length]);

  // Auto save function ==========
  const notInitialRender = React.useRef(false);
  const [hasCourseDataChanges, setHasCourseDataChanges] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const debounceRef = React.useRef<any>(null);
  
  React.useEffect(() => {
    if (notInitialRender.current) {
      setHasCourseDataChanges(true);
    }
  }, [courseData]);
  
  React.useEffect(() => {
    if (!isSaving && notInitialRender.current) {
      // Clear previous debounce
      if (debounceRef.current) {
        debounceRef.current.cancel();
      }
      
      // Create new debounce
      debounceRef.current = debounce(async () => {
        if (notInitialRender.current && (formik.dirty || hasCourseDataChanges) && !isSaving) {
          if (!loading) {
            setIsSaving(true);
            try {
              await formik.handleSubmit();
            } finally {
              setIsSaving(false);
              setHasCourseDataChanges(false);
            }
          }
        }
      }, 1500);
      
      debounceRef.current();
    }
    
    // Cleanup function
    return () => {
      if (debounceRef.current) {
        debounceRef.current.cancel();
      }
    };
  }, [formik.values, hasCourseDataChanges, isSaving, loading, formik.dirty]);

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========
  const [forceRenderKey, setForceRenderKey] = React.useState(0);

  // ModalConfirm state for college course removal
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [removeIndex, setRemoveIndex] = React.useState<number | null>(null);
  
  // ModalCheckCollgeCourseField state for missing values check
  const [showMissingFieldsModal, setShowMissingFieldsModal] = React.useState(false);
  const handleClose = () => {
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  const handleConfirm = (index: number) => {
    const newCourseData = [...courseData];
    newCourseData.splice(index, 1);
    setCourseData(newCourseData);
    setOpenConfirm(false);
    setRemoveIndex(null);
  };

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    let lsData:any[] = [];
    if (courseData && courseData.length>0) {
      lsData = courseData.map( (e:FormCollegeCourse, i:number) => {
        return {...e, index: i+1, lastIndex: i+1}
      });
    }

    const dataList = reorder(lsData, result.source.index, result.destination.index);
    setCourseData([...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'High School Courses' },
          { percentOnProcess: 60, title: 'Course Confirmation' },
        ]}
        title="College Courses"
        process={1}
        icon={<StackedLineChartIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form 
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }} 
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <Row className="m-0">
              <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                  College Courses
                </span>
              </div>

              {/* start warning */}
              {showWarning && (
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <div className="alert alert-danger" role="alert">
                      {errorArr && errorArr.length > 0 && (
                        <>
                          Prior to entering your college by From date, To date, go to Education &gt;
                          <a
                            href={
                              '/#/application/college-and-university/?check=1#' + errorArr[0].value
                            }
                            title="click to return the Colleges & Universities page"
                          >
                            {' '}
                            Colleges & Universities{' '}
                          </a>
                          &nbsp; and enter the following information for each of the college(s) you
                          attended.
                          {` ${errorArr[0].name}`}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* end warning */}

              {courseData.length > 0 && (
                <div className="d-flex justify-content-end">
                  <ExpandMore
                    aria-expanded={expandAll}
                    aria-label="show all"
                    onClick={handleExpandAll}
                  >
                    {!expandAll ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
                  </ExpandMore>
                </div>
              )}

              <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
                <Droppable droppableId="list">
                  {(provided) => (
                    <div className='bg-white py-2 rounded-3 box-collapse' ref={provided.innerRef} {...provided.droppableProps} style={{
                      paddingRight: isMobile ? "10px" : "30px",
                      paddingLeft: "10px"
                    }}>
                      {courseData.map((item, index) => (
                        <div key={index + '-' + courseData.length}>
                          <Draggable draggableId={index + '-' + courseData.length} index={index} isDragDisabled={isMobile}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...(isMobile ? {} : provided.dragHandleProps)}
                              >
                                <div
                                  key={index + '-' + courseData.length}
                                  className="position-relative"
                                >
                                  <CollegeCourseConfig
                                    expandAll={expandAll}
                                    handleExpandActive={handleExpandActive}
                                    handleSave={(values) => {
                                      setCourseData((prev) => {
                                        const newCourseData = [...prev];
                                        const existing = newCourseData[index] ?? {};
                                        const incoming = { ...values };

                                        // Guard: never let a racey empty child save wipe existing courses
                                        const existingCourses = existing.collegeCourseArray ?? [];
                                        const incomingCourses = incoming.collegeCourseArray ?? [];
                                        if (
                                          existingCourses.length > 0 &&
                                          incomingCourses.length === 0
                                        ) {
                                          incoming.collegeCourseArray = existingCourses;
                                        }

                                        newCourseData.splice(index, 1, {
                                          ...existing,
                                          ...incoming,
                                        });
                                        return newCourseData;
                                      });
                                    }}
                                    item={item}
                                    index={index + 1}
                                    total={courseData.length}
                                    isMobile={isMobile}
                                    disabled={reviewedAndComplete}
                                  />
                                  <RemoveCircleOutlineIcon
                                    className="position-absolute text-field-light pointer"
                                    style={{ 
                                      right: isMobile ? '-20px' : '-24px', 
                                      top: '12px',
                                      fontSize: isMobile ? '18px' : '24px',
                                      opacity: reviewedAndComplete ? 0.5 : 1,
                                      cursor: reviewedAndComplete ? 'not-allowed' : 'pointer'
                                    }}
                                    onClick={() => {
                                      if (reviewedAndComplete) return;
                                      setRemoveIndex(index);
                                      setOpenConfirm(true);
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </Draggable>
                        </div>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              <div id="AddCollege" className="my-3 w-100 d-flex flex-column align-items-center">
                <div className="text-field-light sized70">{`You can add up to ${MAX_COLLEGE_TERMS} College Terms`}</div>
                <Button variant="primary" className="p-2 px-5" onClick={handleAddCollege} disabled={reviewedAndComplete}>
                  Add College/Term
                </Button>
              </div>
              <div className="px-md-4 pb-4">
                <div className="label-14px my-3">
                Please indicate that you added all of the courses you have taken or plan to take for every college OR if you have no college courses to report.
                </div>
                <CheckboxInput
                  name="is_finish_adding_all_college_grade"
                  dataUp="cc-reported-all"
                  values={formik.values.is_finish_adding_all_college_grade}
                  onChange={formik.handleChange}
                  label={`I'm finished adding all the college grade classes I've taken or plan to take for every college I've attended OR I have no college courses to report.`}
                  disabled={reviewedAndComplete}
                />
              </div>
            </Row>

            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'}`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {course.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'}`} 
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>

      <ModalConfirm 
        open={openConfirm}
        handleClose={handleClose} 
        handleConfirm={() => {
          if (removeIndex !== null) handleConfirm(removeIndex);
        }}
        title=""
        message="Are you sure you want to remove this college term?"
        confirmText="Remove"
        cancelText="Cancel"
      />

      <ModalCheckCollgeCourseField 
        show={showMissingFieldsModal}
        onClose={() => setShowMissingFieldsModal(false)}
        data={courseData}
      />
    </>
  );
};

export default CollegeCourse;
